// extracted by mini-css-extract-plugin
module.exports = {"cabecalho":"ConfiguracaoFuncoes_cabecalho__3QZOa"};